// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-details-popover__card{bottom:0;max-height:\"100%\";min-height:4.375rem;overflow-x:hidden;overflow-y:auto}@media(max-height:250px){.v-details-popover__card{max-height:120px}}@media(max-height:600px){.v-details-popover__card{max-height:250px}}.v-details-popover__card .v-card-content{padding:2rem .55rem .5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
